import "../../assets/css/pin.css";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Button, Spinner } from "react-bootstrap";
import { confirmacionEmail, confirmacionSMS, UpdatePhone, UpdateEmail, UrlGet, requestCode } from "./method";
import security from "../../assets/svg/pin/cellphone_security.svg";
import Swal from "sweetalert2";
import Encryptor from "../../utils/Encryptor.js";

const INITIAL_TIMER = 180;
const RETRY_TIMER = 180;
const MAX_ATTEMPTS = 3;

export default function Code() {

    const navigate = useNavigate();

    const { id, method, step } = useParams();
    const [numbers, setNumbers] = useState(Array(6).fill(""));
    const [timer, setTimer] = useState(INITIAL_TIMER);
    const [data, setData] = useState(null);

    const [disabled, setDisabled] = useState(false);
    const [leyenda, setLeyenda] = useState("");
    const [message, setMessage] = useState("");
    const [attemptCount, setAttemptCount] = useState(1);
    const [loading, setLoading] = useState(false);

    const inputRefs = useRef([]);
    const wrongPinCountRef = useRef(0);

    useEffect(() => {
        // Función async dentro del useEffect
        const fetchData = async () => {

            const crypto = new Encryptor();
            const decrypted = crypto.decrypt(id);

            let datos = await UrlGet(id);
            
            // Si el teléfono tiene 8 dígitos, agregar el 9 al inicio
            if (datos?.phone && datos.phone.length === 8) {
                datos = {
                    ...datos,
                    phone: '9' + datos.phone
                };
            }
            
            setData(datos);
            setLeyenda(writeLeyenda(datos));
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);

            return () => clearInterval(interval);
        } else if (timer === 0) {
            // When the timer reaches 0, reset sent to false
            setDisabled(true);
        }
    }, [timer]);

    const formatPhone = (phone) => {
        if (phone === "") return "";
        const phoneStr = phone.toString();
        const lastFour = phoneStr.slice(-4);
        return `*****${lastFour}`;
    };

    const formatEmail = (email) => {
        if (email === "") return "";

        // Split the email into two parts: first 8 characters and the rest
        const firstPart = email.slice(0, 8); // First 8 characters
        const rest = email.slice(8); // The rest of the email

        // Replace the rest with asterisks (*)
        const restWithAsterisks = "*".repeat(rest.length);

        // Concatenate the first 8 characters with the rest asterisked
        return `${firstPart}${restWithAsterisks}`;
    };

    const handleFocus = (index) => {
        const updatedNumbers = [...numbers];
        updatedNumbers[index] = "";
        //setNumbers(updatedNumbers); // Uncomment to update numbers
    };

    const handleChange = (index, value) => {
        if (/^[a-zA-Z0-9\b]*$/.test(value)) {
            const updatedNumbers = [...numbers];
            updatedNumbers[index] = value;
            setNumbers(updatedNumbers);

            // If value is not empty, move focus to the next input
            if (value && index < 5) {
                inputRefs.current[index + 1].focus(); // Move focus to next input
            }
        }
    };

    useEffect(() => {
        async function fetchData() {
            const pin = numbers.join("");

            if (pin.length === 6) {
                var url = `${window.location.origin}/pin/code/${id}/${method}`;

                var response = null;
                if (method == "phone") {
                    response = await confirmacionSMS(url, pin);
                    if (response.resultado.codigo == "AU00") {
                        await UpdatePhone(id, false);
                    }
                } else if (method == "email") {
                    response = await confirmacionEmail(url, pin);
                    if (response?.resultado?.codigo == "AU00") {
                        await UpdateEmail(id, false);
                    }
                }

                if (!response.ok) {
                    Swal.fire({
                        icon: "error",
                        title: "¡Error!",
                        text: response.mensaje,
                        confirmButtonText: "ok",
                        allowOutsideClick: false,
                        customClass: {
                            confirmButton: "btn btn-warning",
                            cancelButton: "btn btn-danger",
                        },
                    });
                    return;
                }

                if (response.resultado.codigo == "AU00") {
                    let datos = await UrlGet(id);
                    
                    // Si el teléfono tiene 8 dígitos, agregar el 9 al inicio
                    if (datos?.phone && datos.phone.length === 8) {
                        datos = {
                            ...datos,
                            phone: '9' + datos.phone
                        };
                    }

                    if (!datos.updatePhone && method == "phone") {
                        setMessage("El código ingresado es correcto.");
                        setTimer(0);

                        if (step === "sequential") {
                            // Validación de teléfono exitosa, ahora enviar email
                            Swal.fire({
                                icon: "success",
                                title: "¡Teléfono confirmado!",
                                text: "Ahora procederemos con la confirmación del correo electrónico.",
                                confirmButtonText: "Continuar",
                                allowOutsideClick: false,
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    // Enviar código de email
                                    const emailResponse = await requestCode(datos, 'email');
                                    if (emailResponse.resultado.codigo === "AU00") {
                                        navigate(`/pin/code/${id}/email/final`);
                                    } else {
                                        Swal.fire("Error", "No se pudo enviar el código al correo", "error");
                                    }
                                }
                            });
                        } else if (step === "final") {
                            // Validación final de teléfono, ir al resumen
                            Swal.fire({
                                icon: "success",
                                title: "¡Éxito!",
                                text: "Tu número de teléfono ha sido validado correctamente.",
                                confirmButtonText: "Continuar",
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    navigate("/paet/resumen");
                                }
                            });
                        }
                    }

                    if (!datos.updateMail && method == "email") {
                        setMessage("El código ingresado es correcto.");
                        setTimer(0);

                        // Validación de email siempre es final
                        Swal.fire({
                            icon: "success",
                            title: "¡Éxito!",
                            text: "Tu correo electrónico ha sido confirmado correctamente.",
                            confirmButtonText: "Continuar",
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/paet/resumen");
                            }
                        });
                    }
                } else {
                    wrongPinCountRef.current += 1;
                    
                    if (wrongPinCountRef.current >= MAX_ATTEMPTS) {
                        Swal.fire({
                            icon: "warning",
                            title: "No pudimos verificar tu dato",
                            text: "Superaste el límite establecido de intentos para ingresar el código. Serás dirigido al inicio y deberás repetir el proceso.",
                            confirmButtonText: "Volver al inicio",
                            allowOutsideClick: false,
                            customClass: {
                                confirmButton: "btn btn-outline-primary",
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/pin");
                            }
                        });
                        return;
                    }
                    
                    setMessage("El código ingresado es incorrecto, por favor intenta nuevamente");
                }
            }
        }

        fetchData();
    }, [numbers, navigate]);

    const writeLeyenda = (data) => {
        if (method === "phone") {
            const stepText = step === "sequential" 
                ? "primer código" 
                : "código";
            return (
                <p>
                    <strong>
                        Hemos enviado el {stepText} al número de teléfono {formatPhone(data.phone)}.
                    </strong>
                </p>
            );
        }

        if (method === "email") {
            const stepText = step === "final" && data.updatePhone 
                ? "segundo código" 
                : "código";
            return (
                <p>
                    <strong>
                        Hemos enviado el {stepText} al correo {formatEmail(data.email)}.
                    </strong>
                </p>
            );
        }

        if (method === "both") {
            return (
                <>
                    <p>
                        <strong>
                            Hemos enviado el primer código al número de teléfono {formatPhone(data.phone)}.
                        </strong>
                    </p>
                    <p>
                        <strong>
                            Hemos enviado el segundo código al correo {formatEmail(data.email)}.
                        </strong>
                    </p>
                </>
            );
        }
    };

    const handleResendCode = async () => {
        if (!data || timer !== 0) return;

        if (attemptCount >= MAX_ATTEMPTS) {
            Swal.fire({
                icon: "warning",
                title: "No pudimos verificar tu dato",
                text: "Superaste el límite establecido de solicitudes de códigos de verificación. Serás dirigido al inicio y deberás repetir el proceso.",
                confirmButtonText: "Volver al inicio",
                allowOutsideClick: false,
                customClass: {
                    confirmButton: "btn btn-outline-primary",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate("/");
                }
            });
            return;
        }

        setLoading(true);
        try {
            const response = await requestCode(data, method);
            const isSuccess = response?.resultado?.codigo === "AU00";

            if (!isSuccess) {
                await Swal.fire({
                    icon: "warning",
                    title: `Error al reenviar código ${method === 'phone' ? 'SMS' : 'email'}`,
                    text: response?.resultado?.mensaje || "Error desconocido",
                    confirmButtonText: "Ok",
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: "btn btn-success",
                    },
                });
                return;
            }

            setAttemptCount(attemptCount + 1);
            setTimer(RETRY_TIMER);
            setDisabled(false);
            setNumbers(Array(6).fill(""));
            setMessage("");
            
            await Swal.fire({
                icon: "success",
                title: "Código reenviado",
                text: `Se ha enviado un nuevo código ${method === 'phone' ? 'SMS' : 'al correo'}.`,
                confirmButtonText: "Ok",
                allowOutsideClick: false,
                customClass: {
                    confirmButton: "btn btn-success",
                },
            });

        } catch (error) {
            console.error("Error al reenviar código:", error);
            Swal.fire("Error", "No se pudo reenviar el código de validación.", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <div className="card formulario mt-5 mb-5">
                <div className="card-header">
                    <div className="form-row">
                        <div className="titulo">
                            Formulario de Retiro de Pensión Anticipada por Enfermedad Terminal
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="subtitulo mt-3">
                            Confirmación datos de contacto
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="subtitulo-2 mt-3">
                            {method == "phone" && step == "sequential" ? "Primer paso: Código al teléfono" : ""}
                            {method == "phone" && step == "final" ? "Código al teléfono" : ""}
                            {method == "email" && step == "final" ? 
                                (data?.updatePhone ? "Segundo paso: Código al correo" : "Código al correo") : ""}
                            {method == "both" ? "Código al teléfono y al correo" : ""}
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <Form>
                        <div className="form-row">
                            <div className="form-group col-md-12 text-center">
                                <img src={security} height={280} alt="cellphone security" />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-12 mt-4">
                                <span className="body-text">
                                    {leyenda}
                                </span>
                            </div>
                        </div>

                        {method === "email" && (
                            <div className="form-row">
                                <div className="form-group col-md-12 mt-3">
                                    <div className="alert alert-info" role="alert">
                                        Tu código ha sido enviado, en caso de que no recibas tu clave de 6 dígitos en la bandeja de entrada principal, recuerda verificar en los correos no deseados o SPAM.
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="form-row">
                            <div className="form-group col-md-12 mt-2 text-center">
                                {timer !== 0 ? (
                                    <div className="alert alert-success" role="alert">
                                        Te restan {timer} segundos.
                                    </div>
                                ) : (
                                    <div className="alert alert-danger" role="alert">
                                        Tu tiempo ha expirado.
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="text-center">
                            <div className="row g-2">
                                {numbers.map((number, index) => (
                                    <div className="col-2 col-sm-2 col-md-2" key={index}>
                                        <Form.Control
                                            type="text"
                                            name={index}
                                            className={`form-control-code ${message === '' ? '' : message.includes('incorrecto') ? 'red-Key' : 'green-Key'}`}
                                            maxLength={1}
                                            value={number}
                                            disabled={disabled}
                                            onChange={(e) => handleChange(index, e.target.value)}
                                            onFocus={() => handleFocus(index)}
                                            ref={(el) => inputRefs.current[index] = el}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className={`mt-4 text-center ${message.includes("incorrecto") ? "text-danger" : "text-success"}`}>
                            {message}
                        </div>
                        <div className="form-row mt-4 text-center">
                            <div className="form-group mb-2">
                                <Button
                                    variant="success"
                                    className="col-md-12"
                                    onClick={handleResendCode}
                                    disabled={timer !== 0 || loading}
                                >
                                    {loading ? (
                                        <Spinner animation="border" variant="light" size="sm" />
                                    ) : (
                                        "Solicitar código"
                                    )}
                                </Button>
                            </div>
                            <div className="form-group mb-2">
                                <Button variant="link" className="col-md-12" onClick={() => {
                                    navigate("/pin/send", { state: { data: data } })
                                }}>
                                    Volver al paso anterior
                                </Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
}